import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

interface SearchRecord {
  city_name: string;
  latitude: number;
  longitude: number;
  temperature: number;
  weather_code?: number;
  recommendation_layers: number;
  sensitivity: string;
}

export const recordSearch = async (searchData: SearchRecord) => {
  try {
    const { error } = await supabase
      .from('searches')
      .insert([searchData]);

    if (error) throw error;
  } catch (error) {
    console.error('Error recording search:', error);
  }
};